import { createApp } from "vue"
import { directive } from "@/directive"
import { i18n } from "@/i18n"
import ElementPlus from "element-plus"
import VueGridLayout from "vue-grid-layout"
import pinia from "/@/stores/index"
import App from "./App.vue"
import router from "./router"
import other from "@/utils/other"

import "element-plus/dist/index.css"
import "@/theme/index.scss"
import "@/theme/base.scss"
// import ARMSMonitoring from '@/utils/arms'

// 初始化阿里云arms监控
// setTimeout(() => {
//     try {
//         ARMSMonitoring.init();
//     } catch (error) {
//         console.warn('ARMS 监控初始化失败');
//     }
// }, 0)

const app = createApp(App)

directive(app)

app.use(pinia)
    .use(router)
    .use(ElementPlus, { i18n: i18n.global.t })
    .use(i18n)
    .use(VueGridLayout)
    .mount("#app")
